import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.handleRetry = () => {
            this.setState({ hasError: false, error: null });
        };
        this.state = { hasError: false, error: null };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    componentDidCatch(error, info) {
        if (process.env.NODE_ENV !== 'production') {
            console.error('ErrorBoundary caught:', error, info);
        }
    }
    render() {
        if (this.state.hasError) {
            return (_jsxs("div", { style: {
                    minHeight: '60vh',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '2rem',
                    color: 'var(--text-primary, #e2e8f0)',
                }, children: [_jsx("h2", { style: { marginBottom: '1rem' }, children: "Something went wrong" }), _jsx("p", { style: { marginBottom: '1.5rem', color: 'var(--text-secondary, #94a3b8)' }, children: "An unexpected error occurred. Please try again." }), _jsx("button", { onClick: this.handleRetry, style: {
                            padding: '0.75rem 1.5rem',
                            borderRadius: '8px',
                            border: 'none',
                            background: 'var(--accent-color, #3b82f6)',
                            color: '#fff',
                            cursor: 'pointer',
                            fontSize: '1rem',
                        }, children: "Retry" })] }));
        }
        return this.props.children;
    }
}
export default ErrorBoundary;
